"use strict";

import { createContext } from 'react';
const stub = () => {
  throw new Error('No provider was set');
};
const initialContext = {
  error: null,
  user: null,
  isLoading: true,
  authorize: stub,
  cancelWebAuth: stub,
  sendSMSCode: stub,
  authorizeWithSMS: stub,
  sendEmailCode: stub,
  authorizeWithEmail: stub,
  sendMultifactorChallenge: stub,
  authorizeWithOOB: stub,
  authorizeWithOTP: stub,
  authorizeWithRecoveryCode: stub,
  hasValidCredentials: stub,
  clearSession: stub,
  getCredentials: stub,
  clearCredentials: stub,
  authorizeWithPasswordRealm: stub,
  authorizeWithExchangeNativeSocial: stub,
  revokeRefreshToken: stub,
  resetPassword: stub
};
const Auth0Context = /*#__PURE__*/createContext(initialContext);
export default Auth0Context;
//# sourceMappingURL=auth0-context.js.map